import { useEffect } from 'react';
import { useWebgate } from '@xvia/webgate-connect';
import { setAccessToken } from '@/shared/api/authInterceptor';

/** Propaga o accessToken do portal para o cliente HTTP (que vive fora do React). */
export function WebgateTokenBridge() {
  const { accessToken } = useWebgate();

  useEffect(() => {
    setAccessToken(accessToken);
  }, [accessToken]);

  return null;
}
